import Castilo1 from '../Castilo/Castilo (1).webp'
import Castilo2 from '../Castilo/Castilo (2).webp'
import Castilo3 from '../Castilo/Castilo (3).webp'
import Castilo4 from '../Castilo/Castilo (4).webp'
import Castilo5 from '../Castilo/Castilo (5).webp'
import Castilo6 from '../Castilo/Castilo (6).webp'
import Castilo7 from '../Castilo/Castilo (7).webp'
import Castilo8 from '../Castilo/Castilo (8).webp'



const Castiloimages =[
Castilo1,Castilo2,Castilo3,Castilo4,Castilo5,Castilo6,Castilo7,Castilo8
]

export default Castiloimages;